function FourOhFour(){
    return(
        <h1>404 error</h1>
    )
}

export default FourOhFour;
